/** 
 * vrLogo动画组件
 * 使用开源库 https://github.com/micahrye/react-native-animated-sprite
 */
import React, { Component } from 'react'
// import AnimatedSprite from 'react-native-animated-sprite';
// import monsterSprite from './monsterSprite';
import { isWeb } from '../../utils/tools'
let AnimatedSprite, monsterSprite;
AnimatedSprite = require('./npm/react-native-animated-sprite')
monsterSprite = require('./monsterSprite')

class VrLogo extends Component {
  constructor(props) { 
    super(props)
    this.state = {
      tweenOptions: {
        tweenType: 'sine-wave',
        startXY: [0,0],
        xTo: [0,0],
        yTo: [0,0],
        duration: 10,
        loop: true,
      }
    }
  }

  render() {
    return (
      <AnimatedSprite
        sprite={monsterSprite}
        animationFrameIndex={monsterSprite.animationIndex('ALL')}
        loopAnimation={true}
        coordinates={{
          top: 0,
          left: 0,
        }}
        size={{
          width: monsterSprite.size.width,
          height: monsterSprite.size.height,
        }}
        draggable={true}
        tweenOptions = {this.state.tweenOptions}
        tweenStart={'fromMount'}
        onPress={() => {this.props._onPress();}}
      />
    )
  }
}

export default VrLogo
